import React, { Component } from 'react'
import { v4 } from 'uuid'
import styled from "styled-components"
import Slider from "react-slick"
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ProductCard from "../ProductCard"
import ArrowIcon from "../../components/Icons/ArrowIcon"
import LeftArrowIcon from "../../components/Icons/LeftArrowIcon"

const SlickItem = styled.div`
  display:block !important;
  outline:none;
  max-width:100%;
  text-align: left;
  padding: 10px;
  @media(min-width: 576px) {
    padding: 10px 30px;
  }
  @media(min-width: 1200px) {
  padding: 10px 30px;
  }
  @media(min-width: 1600px) {
    padding: 10px 50px;
  }
  .gatsby-image-wrapper {
    min-height: 200px;
  }  
  .card-body{
    @media(min-width: 992px) {
      width:50%;
    }
    @media(min-width: 1200px) {      
      width:45%;
    }
  }
  .card-img{
    @media(min-width: 992px) {
      width:50%;
    }
    @media(min-width: 1200px) {
      width:55%;
    }
  }
`
const SlickCarousel = styled.div`  
  position:relative;
  padding-bottom:30px;
`
const SlickArrow = styled.div`  
  position:absolute;
  left:50%;
  transform:translateX(-50%);
  bottom:0;
  width:100px;
  display: flex;
  flex-wrap:wrap;
  justify-content: space-between;
  .slick-arrow{
    display:flex;
    align-items:center;
    justify-content:center;
    width: 40px;
    height: 40px;    
    border-radius: 50px;
    background: #fff;
    border: 1px solid #ddd;
    text-align: center;
    cursor: pointer;
    & svg {
      transition: all .3s ease;
      fill: #020304;
    }
    &:hover {
      border: 1px solid #020304;      
    }
  }

`
const LeftArrow = styled.div` 
  left:0;
  &:hover {
    & svg {
      transform: translateX(-5px);
    }
  }
`
const RightArrow = styled.div`
  right:0;
  &:hover {
    & svg {
      transform: translateX(5px);
    }
  }
`

function CircleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <button
      className={className}
      style={{ ...style, display: "flex"}}
      onClick={onClick}
    ><ArrowIcon/></button>
  );
}

function CirclePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <button
      className={className}
      style={{ ...style, display: "flex"}}
      onClick={onClick}
    ><ArrowIcon/></button>
  );
}

export default class SpecialProductCarousel extends Component {
  constructor(props) {
    super(props)
    this.next = this.next.bind(this);
    this.previous = this.previous.bind(this);
  }
  next() {
    this.slider.slickNext();
  }
  previous() {
    this.slider.slickPrev();
  }
  render() {
    const settings = {
      centerMode: true,
      centerPadding: '180px',
      slidesToShow: 1,
      infinite: true,
      slidesToScroll: 1,
      speed: 300,
      nextArrow: <CircleNextArrow />,
      prevArrow: <CirclePrevArrow />,
      arrow: false,
      autoplay: true,
      autoplaySpeed: 3000,
      responsive: [
         {
          breakpoint: 1600,
          settings: {
            centerMode: true,
            centerPadding: '140px',
          }
        },
         {
          breakpoint: 1200,
          settings: {
            centerMode: true,
            centerPadding: '100px',
          }
        },
        {
          breakpoint: 992,
          settings: {
            centerMode: true,
            centerPadding: '60px',
          }
        },
        {
          breakpoint: 767,
          settings: {
            centerMode: true,
            centerPadding: '5px',
          }
        },
        {
          breakpoint: 500,
          settings: {
            centerMode: true,
            centerPadding: '0',
          }
        }
      ]
    };
    const { data } = this.props
    return (
      <SlickCarousel>
        <Slider {...settings} ref={c => (this.slider = c)}>
          {
            data.map((item, i) => {
              return (
                <SlickItem key={v4()}>
                  <ProductCard data={item.node} showQuote={this.props.showQuote} />
                </SlickItem>
              )
            })
          }

        </Slider>
        <SlickArrow>
          <LeftArrow onClick={this.previous} className='slick-arrow'><LeftArrowIcon /></LeftArrow>
          <RightArrow onClick={this.next} className='slick-arrow'><ArrowIcon /></RightArrow>
        </SlickArrow>
      </SlickCarousel>
    );
  }
}
